import { DataProvider } from 'react-admin'
import { ParkingRecordDto } from '../../dto/external-parking/parking-record.dto'

const fakeFiles: ParkingRecordDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
